<template>
<div>
  <v-simple-table>
    <thead>
    <tr>
      <td>Print</td>
      <td>Sample ID</td>
      <td>QA</td>
      <td>LOT</td>
    </tr>
    </thead>
    <tbody>
      <tr v-for="sample in samples">
        <td><v-btn @click="printSpecific(sample)">Print</v-btn></td>
        <td>{{ sample.short_id }}</td>
        <td>{{ sample.qa }}</td>
        <td>{{ sample.lot }}</td>
      </tr>
    </tbody>
  </v-simple-table>
  <v-btn @click="printLabels(samples)">Print all</v-btn>
  <v-btn v-if="!has_manifest" @click="$emit('reset')">Reset Create Form</v-btn>
</div>
</template>

<script>
// import LabelPrinter from "@/Lib/LabelPrinter";
// import FrontOfficeLabel from "@/Lib/Labels/FrontOfficeLabel";
export default {
    name: "StepPrintLabels",
    components: {
      RequiredTests: () => import("@/components/general/samples/RequiredTests")
    },
    data: () => ({
      printing: false,
      samples: [],
      label: null
    }),
    props:{
      has_manifest: {
        type: Boolean,
        default: false,
      }
    },
    mounted(){
      // this.label = new LabelPrinter(dymo);
      // this.label.setPrinter();
    },
    methods: {
      setSamples(samples){
        this.samples = samples;
      },
      printLabels(samples){
        this.samples = samples;
        this.$store.state.dymo.setLabel("FrontOfficeLabel");
        this.$store.state.dymo.createLabels(samples.map(sample => this.$store.state.dymo.labelFormat(sample)), true)
        this.$store.state.dymo.print();
        // this.label.setLabel(FrontOfficeLabel.label())
        // this.label.createLabels(samples, true);
        // this.label.print();
      },
      printSpecific(sample){
        this.$store.state.dymo.setLabel("FrontOfficeLabel");
        this.$store.state.dymo.createLabels(this.$store.state.dymo.labelFormat(sample))
        this.$store.state.dymo.print();
      }
    }
}
</script>

<style scoped>

</style>
